<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="品类" prop="categoryId">
        <a-input v-model="form.categoryId" placeholder="请输入品类" />
      </a-form-model-item>
      <a-form-model-item label="品种名称" prop="name">
        <a-input v-model="form.name" placeholder="请输入品种名称" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getBreed, addBreed, updateBreed } from '@/api/mibo/breed'

export default {
  name: 'CreateForm',
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      form: {
        id: null,
        categoryId: null,
        name: null,
        sort: null,
        status: 1,
        createTime: null,
        remark: null
      },
      formType: 1,
      open: false,
      rules: {
        categoryId: [
          { required: true, message: '品类不能为空', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '品种名称不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    onClose () {
      this.open = false
    },
    cancel () {
      this.open = false
      this.reset()
    },
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        categoryId: null,
        name: null,
        sort: null,
        status: 1,
        createTime: null,
        remark: null
      }
    },
    handleAdd () {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getBreed({ id: id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    submitForm () {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return false
        }
        this.submitLoading = true
        const isEdit = this.form.id !== undefined && this.form.id !== null
        const req = isEdit ? updateBreed(this.form) : addBreed(this.form)
        req.then(response => {
          if (response.success) {
            this.$message.success(isEdit ? '修改成功' : '新增成功', 3)
            this.open = false
            this.$emit('ok')
          } else {
            this.$message.error(response.message || response.msg || (isEdit ? '修改失败' : '新增失败'))
          }
        }).finally(() => {
          this.submitLoading = false
        })
      })
    }
  }
}
</script>
